// NO EDITAR A MANO
import {IIdioma} from "services-comun/modules/net/idiomas";
import {Modulo} from "services-translation/modules/base/modulo";

import {TraduccionCmpGdprAcceptAndContinue} from "./gdpr/accept_and_continue";
import {TraduccionCmpGdprAcceptFree} from "./gdpr/accept_free";
import {TraduccionCmpGdprAccept} from "./gdpr/accept";
import {TraduccionCmpGdprConfigurar} from "./gdpr/configurar";
import {TraduccionCmpGdprConfigure} from "./gdpr/configure";
import {TraduccionCmpGdprDataP1, TraduccionCmpGdprDataP1Params} from "./gdpr/data_p1";
import {TraduccionCmpGdprDataP2, TraduccionCmpGdprDataP2Params} from "./gdpr/data_p2";
import {TraduccionCmpGdprDataP3, TraduccionCmpGdprDataP3Params} from "./gdpr/data_p3";
import {TraduccionCmpGdprNVendors, TraduccionCmpGdprNVendorsParams} from "./gdpr/n_vendors";
import {TraduccionCmpGdprQueryNVendors, TraduccionCmpGdprQueryNVendorsParams} from "./gdpr/query_n_vendors";
import {TraduccionCmpGdprQueryVendors} from "./gdpr/query_vendors";
import {TraduccionCmpGdprRejectAll} from "./gdpr/reject_all";
import {TraduccionCmpGdprRejectAndPay} from "./gdpr/reject_and_pay";
import {TraduccionCmpGdprRejectAndSubscribe} from "./gdpr/reject_and_subscribe";
import {TraduccionCmpGdprReject} from "./gdpr/reject";
import {TraduccionCmpGdprSimple} from "./gdpr/simple";
import {TraduccionCmpGdprSinLogo} from "./gdpr/sin_logo";
import {TraduccionCmpGdprTitle} from "./gdpr/title";

export class TraduccionCmpGdpr extends Modulo {
    /* STATIC */
    // public static ID: string = "cmp.gdpr";
    // public static VERSION: Date = new Date("2024-05-07T08:08:06.481Z");
    // public static HASH: string = "8e1e9d2b3d57e4f3cfd1bd57b0277fa9";

    private static CACHE: {[lang: string]: TraduccionCmpGdpr} = {};

    public static build(lang: IIdioma): TraduccionCmpGdpr {
        return this.CACHE[lang.idioma] ??= new this(lang);
    }

    /* INSTANCE */
    public simple: TraduccionCmpGdprSimple;
    public sin_logo: TraduccionCmpGdprSinLogo;
    public accept: string;
    public accept_free: string;
    public accept_and_continue: string;
    public configurar: string;
    public configure: string;
    public query_vendors: string;
    public reject: string;
    public reject_all: string;
    public reject_and_pay: string;
    public reject_and_subscribe: string;
    public title: string;

    #data_p1: TraduccionCmpGdprDataP1;
    #data_p2: TraduccionCmpGdprDataP2;
    #data_p3: TraduccionCmpGdprDataP3;
    #n_vendors: TraduccionCmpGdprNVendors;
    #query_n_vendors: TraduccionCmpGdprQueryNVendors;

    private constructor(_lang: IIdioma) {
        super(_lang);

        this.simple = TraduccionCmpGdprSimple.build(_lang);
        this.sin_logo = TraduccionCmpGdprSinLogo.build(_lang);
        this.accept = TraduccionCmpGdprAccept.build(this._lang).toString();
        this.accept_free = TraduccionCmpGdprAcceptFree.build(this._lang).toString();
        this.accept_and_continue = TraduccionCmpGdprAcceptAndContinue.build(this._lang).toString();
        this.configurar = TraduccionCmpGdprConfigurar.build(this._lang).toString();
        this.configure = TraduccionCmpGdprConfigure.build(this._lang).toString();
        this.#data_p1 = TraduccionCmpGdprDataP1.build(this._lang);
        this.#data_p2 = TraduccionCmpGdprDataP2.build(this._lang);
        this.#data_p3 = TraduccionCmpGdprDataP3.build(this._lang);
        this.#n_vendors = TraduccionCmpGdprNVendors.build(this._lang);
        this.query_vendors = TraduccionCmpGdprQueryVendors.build(this._lang).toString();
        this.#query_n_vendors = TraduccionCmpGdprQueryNVendors.build(this._lang);
        this.reject = TraduccionCmpGdprReject.build(this._lang).toString();
        this.reject_all = TraduccionCmpGdprRejectAll.build(this._lang).toString();
        this.reject_and_pay = TraduccionCmpGdprRejectAndPay.build(this._lang).toString();
        this.reject_and_subscribe = TraduccionCmpGdprRejectAndSubscribe.build(this._lang).toString();
        this.title = TraduccionCmpGdprTitle.build(this._lang).toString();
    }

    public data_p1(key: string, params: Partial<TraduccionCmpGdprDataP1Params> = {}) {
        return this.#data_p1.render(key, params);
    }
    public data_p2(params: Partial<TraduccionCmpGdprDataP2Params> = {}) {
        return this.#data_p2.render(params);
    }
    public data_p3(key: string, params: Partial<TraduccionCmpGdprDataP3Params> = {}) {
        return this.#data_p3.render(key, params);
    }
    public n_vendors(params: Partial<TraduccionCmpGdprNVendorsParams> = {}) {
        return this.#n_vendors.render(params);
    }

    public query_n_vendors(params: Partial<TraduccionCmpGdprQueryNVendorsParams> = {}) {
        return this.#query_n_vendors.render(params);
    }
}

export default (lang: IIdioma)=>TraduccionCmpGdpr.build(lang);
